<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Competitions
              </div>

              <q-space />
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="dataLoading"
                dense
              >
                <q-badge floating>{{ filtersActive }}</q-badge>
                <q-menu>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <div class="text-h6 q-mb-none">Filters</div>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-btn-group flat push class="full-width">
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Live' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Live' ? 'secondary' : 'accent'
                          "
                          push
                          label="Live"
                          @click="filter.view = 'Live'"
                        />
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Archived' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Archived' ? 'secondary' : 'accent'
                          "
                          push
                          label="Archived"
                          @click="filter.view = 'Archived'"
                        />
                      </q-btn-group>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-select
                        :options="seasons"
                        v-model="filter.season"
                        label="Season"
                        v-bind="siteCFG.fields.general"
                        clearable
                      >
                      </q-select>
                    </div>
                  </div>
                </q-menu>
              </q-btn>
              <q-input
                style="max-width: 45%"
                filled
                class="q-ml-sm"
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 125px) !important"
                >
                  <datatable
                    :filter="filter"
                    :externalFilter="externalFilter"
                    :flat="true"
                    hide-pagination
                    :data="
                      gridData.sort((a, b) => {
                        // current date + 1 day
                        let futureDate = $moment().subtract(1, 'day');
                        if (
                          $moment(a.end_date) < futureDate &&
                          $moment(b.end_date) >= futureDate
                        )
                          return 1;
                        if (
                          $moment(a.end_date) >= futureDate &&
                          $moment(b.end_date) < futureDate
                        )
                          return -1;
                        if ($moment(a.start_date) < $moment(b.start_date))
                          return -1;
                        if ($moment(b.start_date) < $moment(a.start_date))
                          return 1;
                        return 0;
                      })
                    "
                    :columns="columns"
                    @rowSelected="handleDoubleClick"
                  >
                    <template slot="body-cell-start_date" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <span>
                          <b>
                            Start:
                          </b>
                          {{
                            $moment(data.props.row.start_date).format("DD-MMM")
                          }}
                        </span>
                        <span>
                          <br />
                          <b>
                            End:
                          </b>
                          {{
                            $moment(data.props.row.end_date).format("DD-MMM")
                          }}
                        </span>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <q-btn
                          @click="handleDoubleClick(data.props.row)"
                          round
                          flat
                          color="black"
                          dense
                        >
                          <q-icon name="mdi-open-in-new"></q-icon>
                          <q-tooltip>Open Competition</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "competitions/listLive",
      dataLoading: "competitions/listLoading",
      seasons: "settings/availableSeasons",
      siteCFG: "settings/siteCFG"
    }),
    filtersActive: function() {
      let count = 0;

      if (this.filter.season) {
        count += 1;
      }

      return count;
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "competition_name",
        label: "Competition",
        align: "left",
        field: "competition_name",
        style: "white-space: normal; word-wrap: break-word;",
        sortable: true
      },
      {
        name: "start_date",
        label: "Dates",
        align: "left",
        field: "start_date",
        format: val => (val != null ? moment(val).format("DD-MMM") : ""),
        sortable: true
      }
    ],

    archivingCompetitionID: null,

    // Filter
    filter: {
      search: "",
      view: "Live",
      status: null,
      season: `${
        new Date().getMonth() >= 6 ? moment().year() : moment().year() - 1
      }-${new Date().getMonth() >= 6 ? moment().year() + 1 : moment().year()}`
    }
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}/events`);
    },
    loadData() {
      this.$store.dispatch("competitions/loadAll");
    },
    // Grid Filter
    externalFilter(rows, terms, cols) {
      return rows.filter(row => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "" && this.filter.search) {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Archived Filter
        if (
          (this.filter.view == "Live" && !row.archived_at) ||
          (this.filter.view == "Archived" && row.archived_at)
        ) {
          passed += 1;
        }

        // Season Filter
        if (this.filter.season) {
          let seasonStart = moment(
            `${this.filter.season.split("-")[0]}-07-01`
          ).startOf("day");
          let seasonEnd = moment(
            `${this.filter.season.split("-")[1]}-06-30`
          ).endOf("day");
          if (
            (moment(row.end_date) > seasonStart &&
              moment(row.end_date) < seasonEnd) ||
            row.end_date == null
          ) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        // Status Filter
        if (this.filter.status) {
          if (
            this.filter.status == "entriesOpen" &&
            moment(row.entriesCloseDate) > moment()
          ) {
            passed += 1;
          } else if (
            this.filter.status == "active" &&
            moment(row.start_date) < moment() &&
            moment(row.end_date) > moment()
          ) {
            passed += 1;
          } else if (
            this.filter.status == "finishedOrClosed" &&
            moment(row.end_date) < moment()
          ) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        if (passed == 4) {
          return true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
